import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  title: {
    textTransform: 'uppercase',
  },
}))

export default styles
